exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1Jb_ {\n    padding-right: 6px;\n}\n\n._3fEj {\n    padding-left: 6px;\n}\n\n.nN6D {\n    text-align: center;\n    padding-top: 10px;\n}\n\n._2ehR {\n    text-align: center;\n}\n\n._3qZY {\n    padding-top: 4px;\n    padding-bottom: 4px;\n    text-align: center;\n}\n\n.UviW {\n    margin-bottom: 15px;\n    padding: 0;\n}\n\n.f4pw {\n    padding: 8px;\n    font-size: 12px;\n}\n\n._32al {\n    padding-bottom: 20px;\n    padding-top: 10px;\n    text-align: center;\n}\n\n._1YId {\n        @media screen and (max-width: 768px) {\n    .saPQ > ._21UC {\n            padding: 0\n    }\n        }\n}\n\n._1vmy {\n    padding: 5px 15px 20px;\n}\n\n.lNRD {\n    padding-right: 15px;\n    padding-left: 15px;\n    padding-bottom: 10px;\n}\n\n.iI-s {\n    color: #707172;\n    font-size: 16px;\n    margin-top: 18px;\n}\n\n@media (max-width: 450px) {\n    .iI-s {\n        display: none;\n    }\n}\n\n._1s1u {\n    padding-top: 10px;\n    text-align: center;\n}\n\n.IrcJ {\n    border: 2px solid var(--primary-colour);\n    border-radius: 2em;\n    color: var(--primary-colour);\n    padding: 3px;\n}\n\n._3WLe {\n    margin-top: 10px;\n    border: 1px solid var(--primary-colour);\n    border-left: 5px solid var(--primary-colour);\n    border-radius: 0.5em;\n    padding: 0.7em 1.2em;\n}\n", ""]);

// exports
exports.locals = {
	"registerGroupLeft": "_1Jb_",
	"registerGroupRight": "_3fEj",
	"registerGroupCenterButton": "nN6D",
	"error": "_2ehR",
	"registerGroupLabel": "_3qZY",
	"registerGroupToggleContainer": "UviW",
	"registerGroupAlert": "f4pw",
	"registerPagePanelHeader": "_32al",
	"registerPanel": "_1YId",
	"panel": "saPQ",
	"panel-body": "_21UC",
	"dataUsage": "_1vmy",
	"checkBoxes": "lNRD",
	"verificationWarning": "iI-s",
	"customPreSignupText": "_1s1u",
	"ambassadorWarningIcon": "IrcJ",
	"ambassadorWarning": "_3WLe"
};